import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Anchor, FormHelp } from '@zillow/constellation';

import { RMWContext } from 'app/shared/providers/RMWContext';
import { UserSelectors } from 'app/shared/selectors';

const propTypes = {
    modalClose: PropTypes.func.isRequired,
};

const CustomerSupportErrorMessage = ({ modalClose }) => {
    const { paths } = useContext(RMWContext);
    const { features: { canAddListing } } = useSelector(state => UserSelectors.makeUser(state));
    const addNewPropertyUrl = `${paths.propertiesPage}?postingPath=true&itc=ZRMEditAddressAddNew`;

    return (
        <FormHelp error={true}>
            Please contact&nbsp;
            <Link
                component={Anchor}
                target="_blank"
                to={paths.helpPage}
                escape={true}
            >
                customer support
            </Link>
            &nbsp;if there is an error with the address.
            {canAddListing && (
                <>
                    <br />
                    You can also&nbsp;
                    <Anchor
                        fontType="bodySmall"
                        onClick={() => {
                            window.router.transitionTo(addNewPropertyUrl);
                            modalClose();
                        }}
                    >
                        add a new property or unit
                    </Anchor>
                    .
                </>
            )}
        </FormHelp>
    );
};

CustomerSupportErrorMessage.propTypes = propTypes;

export default CustomerSupportErrorMessage;
